import type {ApiQueryParams} from '@/types/api';

export const userKeys = {
  all: ['user'] as const,

  whoami: ['whoami'] as const,

  lists: () => [...userKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams<{assetId: string}> = {}) =>
    [...userKeys.lists(), filters] as const,

  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: string) => [...userKeys.all, 'detail', id] as const,
};

export const companyKeys = {
  all: ['company'] as const,
};

export const documentKeys = {
  all: ['document'] as const,

  lists: () => [...documentKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams<{assetId: string}> = {}) =>
    [...documentKeys.lists(), filters] as const,

  details: () => [...documentKeys.all, 'detail'] as const,
  detail: (id: string) => [...documentKeys.all, 'detail', id] as const,
};
